"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _SentToUser = _interopRequireDefault(require("@rsuite/icon-font/lib/people/SentToUser"));

// Generated by script, don't edit it please.
var SentToUser = (0, _createSvgIcon["default"])({
  as: _SentToUser["default"],
  ariaLabel: 'sent to user',
  category: 'people',
  displayName: 'SentToUser'
});
var _default = SentToUser;
exports["default"] = _default;
module.exports = exports.default;